import axios, {AxiosError, AxiosInstance, AxiosResponse} from 'axios';
import {initialLocale, locales} from '@/translations';

//@ts-ignore
let locale = initialLocale;
locale = Object.keys(locales).indexOf(locale) > -1 ? locale : initialLocale;

const axiosInstance: AxiosInstance = axios.create({
	baseURL: `${serverVariables.httpRequest.basePath}${process.env.API_URL}/`/*'http://localhost/kredia-orkacard/api/v1/'*/,
	timeout: 300000
});


//TODO turn on in production
//axiosInstance.defaults.withCredentials = true;

axiosInstance.interceptors.response.use((response: AxiosResponse) => response, (error: AxiosError & { __CANCEL__: boolean }) => {
	// request cancellation
	if (error.__CANCEL__) {
		return false;
	}

	// actual request error
	return Promise.reject(error);
});

export default axiosInstance;
